import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { EmptyPropsWithChildren } from '@m43/core';

export function WorkspacePanelsDnDProvider({ children }: EmptyPropsWithChildren) {
    return <DndProvider backend={HTML5Backend}>{children}</DndProvider>;
}
